import type { Dayjs } from 'dayjs';

import { toDayjs } from './myndighetsdatum';

import type { IAnvändare, IOrganisation } from 'src/types/nya/common';

// ----------------------------------------------------------------------

/**
 * Dagen att-göra-listans grind mäter mot: myndighetsuppgifter som förföll dessförinnan visas
 * inte, eftersom ingen ska mötas av röda påminnelser om tidpunkter som passerade innan saken
 * fanns i Flinky.
 *
 * Vilken dag som gäller beror på vems uppgifter som räknas ut:
 *
 * - **En riktig förening ⇒ föreningens dag.** Stämma, arbetsgivardeklaration och moms är
 *   föreningens uppgifter, så hela styrelsen ska se samma lista — och en ledamot som kom in i
 *   går ska se föreningens verkliga eftersläpningar, inte en tom sida.
 * - **Ingen förening ⇒ användarens dag.** Det är hubbläget "Alla organisationer", där det är
 *   personens egna datum som byggs (Inkomstdeklaration 1). De hör till personen.
 *
 * Egen modul och inte en ternär inne i `useAttGöra`, så att regeln går att pröva: kastas valet
 * om slutar en styrelseledamot se sin förenings eftersläpningar, och inget typfel fångar det.
 *
 * Båda datumen kommer ur databasen (`användare.skapad`, `organisationer.skapad`). Tidigare lästes
 * Firebase-kontots `creationTime`, som är fel källa på två sätt: det lokala inloggningsläget
 * sätter den aldrig, så grinden stod i praktiken avstängd, och kontot kan vara äldre än
 * föreningens anslutning.
 */
export function väljIAppenSedan(
  förening?: Pick<IOrganisation, 'skapad'>,
  anvandare?: Pick<IAnvändare, 'skapad'>
): Dayjs | undefined {
  return toDayjs(förening ? förening.skapad : anvandare?.skapad) ?? undefined;
}
